import React, { useState, useCallback, useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Popup } from './Popup';
import { DataGrid, SelectBox } from 'devextreme-react';
import { Column, Scrolling, Selection } from 'devextreme-react/data-grid';
import { columnAttrList } from './columnDataGrid';
import { isActive } from '../../../utils/functions';
import style from './configurestock.module.scss';

const renderAttributes = columnAttrList.map(item => (
  <Column
    dataField={item.dataField}
    key={item.dataField}
    caption={item.caption}
    visible
    allowFiltering
    dataType={item.dataType}
    width={item.width}
  />
));
function isSelectable(item) {
  return !isActive(item.isActive);
}

const AddAttrModal = ({
  isOpen,
  onClose,
  onAction,
  plantConfigOperationsId
}) => {
  const [inheritType, setInheritType] = useState(null);
  const [selectedAttrRows, setSelectedAttrRows] = useState([]);
  const [defaultSelectedRowKeys, setDefaultSelectedRowKeys] = useState([]);
  const configuratorStore = useSelector(state => state.configuratorReducer);

  const onEditorPreparing = useCallback(e => {
    if (e.type !== 'selection') return;
    if (e.parentType === 'dataRow' && e.row && !isSelectable(e.row.data)) {
      e.editorOptions.disabled = isActive(e.row.data.isActive);
    }
    if (e.parentType === 'headerRow') {
      e.editorOptions.visible = false;
      e.editorOptions.disabled = true;
    }
  }, []);

  const onSelectionChanged = useCallback(e => {
    setSelectedAttrRows(e.selectedRowsData);
  }, []);

  useEffect(() => {
    setDefaultSelectedRowKeys(
      configuratorStore.skuAttributes.map(attr => attr.attribCatalogueId)
    );
  }, [configuratorStore.skuAttributes]);

  const dataSource = useMemo(() => {
    return configuratorStore.allAttributes.map(attr => ({
      ...attr,
      isActive: defaultSelectedRowKeys.includes(attr.attribCatalogueId)
        ? 'Y'
        : 'N'
    }));
  }, [defaultSelectedRowKeys, configuratorStore.allAttributes]);

  const handleClose = () => {
    setInheritType(null);
    setSelectedAttrRows([]);
    setDefaultSelectedRowKeys([]);
    onClose();
  };

  const onSubmit = () => {
    if (selectedAttrRows.length) {
      onAction({
        inheritParent: inheritType.plantConfigInheritTypeId,
        plantConfigOperationsId,
        plantOperationAttribsDtos: selectedAttrRows.map(row => ({
          ...row,
          isActive: 'Y',
          inheritParent: inheritType.plantConfigInheritTypeId,
          plantConfigOperationsId
        }))
      });
      handleClose();
    }
  };

  return (
    <Popup
      open={isOpen}
      onClose={handleClose}
      title="Добавить связь операции и атрибута"
      onAction={onSubmit}
      actionBtnTitle="Добавить"
    >
      <div className="optionsData">
        <span>Список типов наследования</span>
        <SelectBox
          stylingMode="outlined"
          items={configuratorStore.inheritTypes}
          displayExpr="plantConfigInheritTypeDesc"
          placeholder="Выберите тип наследования"
          searchEnabled
          value={inheritType}
          onValueChanged={({ value }) => setInheritType(value)}
        />
      </div>
      {inheritType && (
        <div className="optionsData">
          <span>Атрибуты</span>
          <DataGrid
            columnAutoWidth
            showBorders
            dataSource={dataSource}
            height={'400'}
            defaultSelectedRowKeys={defaultSelectedRowKeys}
            keyExpr={'attribCatalogueId'}
            onEditorPreparing={onEditorPreparing}
            onSelectionChanged={onSelectionChanged}
            onCellPrepared={(e) => {
              if (e.rowType === 'data') {
                if (e.column.type === 'selection' && e.data.isActive === 'Y') {
                  e.cellElement.classList.add(style.dxSelectionDisable);
                  e.cellElement.setAttribute('disabled', true);
                }
              }
            }}
          >
            <Selection
              mode="multiple"
              allowSelectAll={false}
              showCheckBoxesMode="always"
            />
            <Scrolling mode="virtual" />
            {renderAttributes}
          </DataGrid>
        </div>
      )}
    </Popup>
  );
};

export default React.memo(AddAttrModal);
